/* MODULE IMPORTS */
import React, { Component } from "react";

import "./CampanhaReformaPopup.css";

class SubscricaoReforcoPopup extends Component {
    static displayName = SubscricaoReforcoPopup.name;

    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <div className="popup-campanha" style={{ backgroundColor: "#ff5800" }}>
                <div className="popup-content" style={{ padding: "40px", justifyContent: "center" }}>
                    <button
                        className="popup-close"
                        onClick={() => {
                            this.props.close();
                        }}
                    >
                        X
                    </button>
                    <div className="popup-campanha-text" style={{ textAlign: "center", width: "100%" }}>
                        <h2 style={{ color: "#ffffff" }}>Subscrição e reforço de modalidades</h2>
                        <p style={{ color: "#ffffff" }}>
                            Por constrangimentos de natureza operacional,<br />
                            não será possível realizar subscrições e/ou reforços de modalidades<br />
                            em My Montepio no período da tarde do dia 1 de maio.
                        </p>
                    </div>
                </div>
            </div>
        );
    }
}

export default SubscricaoReforcoPopup;
